import { defineStore } from "pinia";
import { ref } from "vue";

export const useHomeTabsStore = defineStore("homeTabsStore", () => {
  const selectedRightSectionTab = ref("report_summary");
  const selectedMainTab = ref("featured");
  const listType = ref("grid");
  const showRightSection = ref(false);
  const isInitialLoad = ref(true);

  const handleShowRightSection = () => {
    if (!isInitialLoad.value) {
      return;
    }
    isInitialLoad.value = false;
    showRightSection.value = true;
  };

  return {
    selectedRightSectionTab,
    selectedMainTab,
    listType,
    showRightSection,
    isInitialLoad,
    handleShowRightSection,
  };
});
